import script from "./News.vue?vue&type=script&setup=true&lang=js"
export * from "./News.vue?vue&type=script&setup=true&lang=js"

import "./News.vue?vue&type=style&index=0&id=53a00c16&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53a00c16"]])

export default __exports__